<span class="sr-only" aria-live="polite" role="status">{{ announcement }}</span>

<ng-container *ngIf="visible">
  <section
    *ngIf="!minimized || showSuccess"
    class="stb"
    [class.stb--success]="showSuccess"
    role="region"
    aria-labelledby="stb-title"
  >
    <ng-container *ngIf="!showSuccess; else success">
      <header class="stb__head">
        <div>
          <h2 id="stb-title" class="stb__title">Finish setting up</h2>
          <p class="stb__progress">{{ doneCount }} of {{ tasks.length }} done</p>
        </div>
        <button type="button" class="stb__min" (click)="minimize()" aria-label="Minimize setup checklist">
          <i class="bi bi-dash-lg" aria-hidden="true"></i>
        </button>
      </header>
      <div
        class="stb__bar"
        role="progressbar"
        aria-label="Setup progress"
        [attr.aria-valuenow]="doneCount"
        aria-valuemin="0"
        [attr.aria-valuemax]="tasks.length"
      >
        <span [style.width.%]="progressPercent"></span>
      </div>
      <ul class="stb__list">
        <li *ngFor="let t of tasks; trackBy: trackById" [class.is-done]="t.done">
          <i class="bi" [ngClass]="t.done ? 'bi-check-circle-fill' : 'bi-circle'" aria-hidden="true"></i>
          <span>
            {{ t.label }}
            <span class="sr-only">{{ t.done ? '(done)' : '(not done)' }}</span>
            <small *ngIf="t.sublabel && !t.done">{{ t.sublabel }}</small>
          </span>
        </li>
      </ul>
      <button type="button" class="stb__cta" (click)="verify()">Verify now</button>
    </ng-container>
    <ng-template #success>
      <h2 id="stb-title" class="stb__title"><i class="bi bi-check-circle-fill" aria-hidden="true"></i> All set</h2>
      <p class="stb__progress">Your coaches can now reach you on WhatsApp.</p>
    </ng-template>
  </section>

  <button
    *ngIf="minimized && !showSuccess"
    type="button"
    class="stb-pill"
    [attr.aria-label]="'Finish setting up, ' + pendingCount + (pendingCount === 1 ? ' task' : ' tasks') + ' left. Expand checklist'"
    (click)="expand()"
  >
    Setup · {{ pendingCount }} left
  </button>
</ng-container>
